import React from 'react';
import moment from "moment";
import { Link } from 'react-router';
import API from "../base/API";
import Auth, { hasPermission } from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import EditButton from "../base/EditButton";
import * as TestsCreators from "../../redux/creators/tests";
import { connect } from "react-redux";
import { translate } from "../base/Translation";

export class Tests extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_tests: "/test/list?limit_from=:from&limit_max=:to&brand=:brand",
			delete_test: "/test/delete/:test"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			tests: [],
			tableData: [],
			tableColumns: [
				{ name: "result", display: "#", sort: true, width: 3 },

				{ name: "form_res", display: translate("Kom."), sort: true, width: 5 },
				{ name: "protocol_res", display: translate("Tech."), sort: true, width: 5 },

				{ name: "name", display: translate("Názov"), sort: true, width: 20 },
				{ name: "brand", display: translate("Značka"), sort: true, width: 11 },
				{ name: "branch", display: translate("Prevádzka"), sort: true, width: 20 },
				{ name: "city", display: translate("Obec"), sort: true, width: 12 },
				{ name: "status", display: translate("Stav"), sort: true, width: 9 },
				{ name: "date_date", display: translate("Dátum testu"), sort: true, width: 10 },
				{ name: "options", display: " ", width: 5 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (test) {
			let data = {};
			data.result = (
				<div>
					<span style={{ display: "none" }}>{test.result.percent}</span>
					<span style={{ color: (test.result.success ? "green" : "red") }} className={"glyphicon glyphicon-" + (test.result.success ? "ok" : "remove")} title={test.result.percent + "%"} />
				</div>
			);

			data.protocol_res = (
				<div >
					<span style={{ display: "none" }}>{test.result.protocol_perc}</span>
					<span style={{ color: test.result.protocol_perc >= test.result.protocol_min ? "blue" : "red" }}>
						{test.result.protocol_perc} %
					</span>
				</div>
			);
			data.form_res = (
				<div>
					<span style={{ display: "none" }}>{test.result.form_perc}</span>
					<span style={{ color: test.result.form_perc >= test.result.form_min ? "blue" : "red" }}>
						{test.result.form_perc} %
					</span>
				</div>
			);

			data.name = <Link to={"/tests/" + test.id}>{test.name}</Link>;
			data.brand = test.branch_data.brand;
			data.branch = test.branch_data.name;
			data.city = test.branch_data.address.split(",")[0];
			data.status = test.status;
			data.date_date = moment(test.date, "DD/MM/YYYY").format("D.M.Y");
			data.options = (
				<div style={{ textAlign: "right" }}>
					<EditButton to={"/tests/edit/" + test.id} className="btn btn-xs btn-primary" permission={hasPermission("TestEdit", test)} />
					<DeleteButton onClick={this.deleteTest.bind({ test: test.id, currentComponent: this })} permission={"TestDelete"} />
				</div>
			);
			return data;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");
		this.props.fetch(this.state.limit_from, this.state.limit_to, (brandFilter ? brandFilter.id : "all"));
	}

	deleteTest(evt) {
		this.currentComponent.api.request({
			route: "delete_test",
			params: { test: this.test },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	render() {
		const data = this.convertDataForTable(this.props.testsStore.items);

		return (
			<SorTable columns={this.state.tableColumns} data={data} headers={true} searchBy="name" title={translate("Testy")} right={() => {
				if (Storage.get("allowed_components").indexOf("TestNew") === -1) {
					return "";
				}

				return (
					<Link to="/tests/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}}
				beforeSearchInput={(data) => {
					let totalProtocolPertcent = 0;
					let totalFormPercent = 0;
					data.forEach((item) => {
						totalProtocolPertcent += parseInt(item.protocol_res.props.children[0].props.children, 10);
						totalFormPercent += parseInt(item.form_res.props.children[0].props.children, 10);
					});
					return (
						<span>
							<span className="pull-right" style={{ lineHeight: "3rem", paddingRight: "2rem" }}>
								{translate("Priemerný výsledok technika: ")} {Math.round(totalProtocolPertcent / data.length) + " %"}
							</span>
							<span className="pull-right" style={{ lineHeight: "3rem", paddingRight: "2rem" }}>
								{translate("Priemerný výsledok komunikácia: ")} {Math.round(totalFormPercent / data.length) + " %"}
							</span>
						</span>
					);
				}}
			/>
		);
	}
}


const mapStateToProps = (state) => {
	return { testsStore: state.tests };
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetch: (from, to, brand) => dispatch(TestsCreators.fetch(from, to, brand))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Tests);


// WEBPACK FOOTER //
// ./src/modules/test/Tests.js